import Base from "./Base";

export default class Recipe extends Base {
    list = (nextPage) => {
        if (nextPage) {
            return this.raw().get(nextPage);
        }
        return this.get(`/recipes`);
    }

    find = (id) => (
        this.get(`/recipes/${id}`)
    )

    findByIds = (ids) => (
        this.get(`/recipes?ids=${JSON.stringify(ids)}`)
    )

    search = (query) => (
        this.get(`/recipes?search=${query}`)
    )
    
    searchByTags = (tags) => (
        this.get(`/recipes?tags=${JSON.stringify(tags)}`)
    )

    remove = (id) => (
        this.delete(`/recipes/${id}`)
    )
}



// WEBPACK FOOTER //
// ./src/services/api/Recipe.js